module.exports = __webpack_public_path__ + "static/media/upload-id.f526010b.jpg";